exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
exports.i(require("-!../../../../../../../../../../node_modules/css-loader/dist/cjs.js??ref--16-1!../../../../../../../../../../node_modules/postcss-loader/dist/cjs.js??ref--16-2!../../slide.css"), "");

// Module
exports.push([module.id, "", ""]);

